import { useState } from "react";

interface ShareBarProps {
  title: string;
  onNotify: (message: string) => void;
}

const socials = [
  { key: "wechat", label: "微信", icon: "ri-wechat-fill" },
  { key: "weibo", label: "微博", icon: "ri-weibo-fill" },
  { key: "douyin", label: "抖音", icon: "ri-music-2-fill" },
];

export default function ShareBar({ title, onNotify }: ShareBarProps) {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement("textarea");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    onNotify("链接已复制，可以分享给朋友了");
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-background-200 bg-background-100/70 p-3">
      <span className="mr-1 flex items-center gap-1.5 text-xs text-foreground-500">
        <i className="ri-share-forward-line text-primary-500" />
        分享这篇内容
      </span>
      <button
        type="button"
        onClick={copyLink}
        className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className={copied ? "ri-check-line" : "ri-link"} />
        {copied ? "已复制" : "复制链接"}
      </button>
      {socials.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onNotify(`演示功能：暂未连接${item.label}，可通过复制链接分享「${title.slice(0, 12)}…」`)}
          aria-label={`分享到${item.label}`}
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className={`${item.icon} text-sm`} />
        </button>
      ))}
    </div>
  );
}